import React from 'react';
import { CloudinaryComponentProps, ImageSizeType, VideoSizeType } from 'cloudinary-react';

import DocumentMedia from 'consumer-talent/src/components/MediaRequest/components/UploadMedia/AttachedMediaBlock/DocumentMedia';
import { gqlMediaTypeCodeEnum as MEDIA_TYPE, gqlMedia, gqlMediaStorageEnum } from '@minecraft.graphql-types';
import CloudinaryVideoAudio from '@minecraft.cloudinary-video-audio';
import CloudinaryPhoto, { CloudinaryPhotoProps } from '@minecraft.cloudinary-photo';

type AudioVideoProps = {
  type?: VideoSizeType;
} & CloudinaryComponentProps;

type PhotoProps = {
  type?: ImageSizeType;
} & CloudinaryPhotoProps;

type Props = {
  media: gqlMedia;
  onClick?: (media: gqlMedia) => void;
} & (AudioVideoProps | PhotoProps);

// This is intended to be a universal, unopinionated media component that can be used as the foundation for specific uses and layouts.
// Ideally, we'll continue to use this and refactor media component usage throughout the app to use this component. (or decide it's not viable and remove it)
const MediaComponent = ({ media, onClick, ...rest }: Props) => {
  if (!media) return null;
  const handleClick = () => onClick?.(media);

  switch (media?.mediaType.code) {
    case MEDIA_TYPE.AUDIO:
    case MEDIA_TYPE.VIDEO:
      return (
        <CloudinaryVideoAudio
          mediaType={media?.mediaType?.code}
          mediaStatus={media?.mediaStatus?.code as gqlMediaStorageEnum}
          fileKey={media?.fileKey}
          mediaStorageStatus={media?.mediaStorageStatus?.code}
          thumbnailUrl={media?.thumbnailUrl}
          thumbnail={media?.thumbnail as gqlMedia}
          onClick={handleClick}
          transformation={media?.transformation}
          isThumbnail
          {...rest}
        />
      );

    case MEDIA_TYPE.PHOTO:
      return (
        <CloudinaryPhoto
          fileKey={media?.fileKey}
          onClick={handleClick}
          mediaStorageStatus={media?.mediaStorageStatus?.code}
          transformation={media?.transformation}
          thumbnail={media?.thumbnail as gqlMedia}
          alt={media?.name}
          showThumbnail
          {...rest}
        />
      );

    case MEDIA_TYPE.DOCUMENT:
      return <DocumentMedia media={media} {...rest} />;

    default:
      return null;
  }
};

export default MediaComponent;
